var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 0.839966H5.27L0 6.10997V13.57L5.27 18.84H12.73L18 13.57V6.10997L12.73 0.839966ZM9 15.14C8.28 15.14 7.7 14.56 7.7 13.84C7.7 13.12 8.28 12.54 9 12.54C9.72 12.54 10.3 13.12 10.3 13.84C10.3 14.56 9.72 15.14 9 15.14ZM10 10.84H8V4.83997H10V10.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid10);
export default __webpack_public_path__ + "static/media/grid10.56becaa7e9e633f8b4fb62478fd35946.svg";
export { ForwardRef as ReactComponent };